import Punschfest2024 from '@/views/Public/Event/Punschfest2024.vue';

import PublicBase from '@/views/Public/Layout.vue';

import PubTrainingCeo from '@/views/Public/Training/Ceo.vue';

import PubEventGuest from '@/views/Public/Event/Guest.vue';
import PublicEventQrGuest from '@/views/Public/Event/QrGuest.vue';
import PubEventHost from '@/views/Public/Event/Host.vue';
import Punschfest2025 from "@/views/Public/Event/Punschfest2025.vue";
import SwvFruehstueck2026 from "@/views/Public/Event/SwvFruehstueck2026.vue";
import SwvDatenschutz from "@/views/Public/Event/SwvDatenschutz.vue";

export default [
  {
    path: '/pub/swv-fruehstueck-2026',
    name: 'SwvFruehstueck2026',
    component: SwvFruehstueck2026,
  },
  {
    path: '/pub/swv-datenschutz',
    name: 'SwvDatenschutz',
    component: SwvDatenschutz,
  },
  {
    path: '/pub',
    name: 'PublicBase',
    component: PublicBase,
    redirect: {name: 'GuestHome'},
    children: [
      {
        path: 'training/:trainingId/:ceoId',
        props: true,
        name: 'PublicTrainingCeo',
        component: PubTrainingCeo,
      },
      {
        path: 'event/0b5b0461-2a47-4e20-952d-fd3f80861443/fdb6e433-418f-427a-807e-95ab7ec40e26',
        redirect: {name: 'Punschfest2025'},
      },
      {
        path: 'event/:eventId/:guestId',
        props: true,
        name: 'PublicEventGuest',
        component: PubEventGuest,
      },
      {
        path: 'veranstaltung/qr/:eventId',
        props: true,
        name: 'PublicEventQrGuest',
        component: PublicEventQrGuest,
      },
      {
        path: 'punschfest2024',
        name: 'Punschfest2024',
        component: Punschfest2024,
      },
      {
        path: 'punschfest2025',
        name: 'Punschfest2025',
        component: Punschfest2025,
      },
      {
        path: 'eventhost/:eventId/:hostId',
        props: true,
        name: 'PublicEventHost',
        component: PubEventHost,
      },
    ],
  },
];
